import type { ExperimentConfig } from '../@types'

const config: ExperimentConfig[] = [
	{
		'activity-female-pilates': {
			// /result_complete?safe&mock-data&utm_source=FB&country=US&area=activity-female-pilates&exp=web_pricing_on_pilates_funnel_with_sp~1
			paywall: {
				experiment: () =>
					import(
						/* webpackChunkName: "plan" */ '@/modules/Paywall/instances/experiments/web_pricing_on_pilates_funnel_with_sp'
					),
			},
			upgrade: {
				routeName: null,
			},
		},
	},
]

export default config
